import { api } from '@/api';
import { queryClient } from '@/queries';
import { AirportType } from '@/api/apis/facilities';

export const seedAirportsList = (items: AirportType[]) => {
  items.forEach((item) => {
    queryClient.setQueryData(['airports', 'item', `${item.maoId}`, 'maoIds'], item);
    queryClient.setQueryData(['airports', 'item', item.id, 'ids'], item);
  });
};

export const getAirportById = async (id: string, idsFilterType: 'ids' | 'maoIds' = 'ids') => {
  const response = await api.airports.getAirportsByIds(id, idsFilterType);
  const airport = response.items[0];
  if (airport) {
    const airportIdKey = idsFilterType === 'ids' ? 'maoIds' : 'ids';
    const airportId = idsFilterType === 'ids' ? airport.maoId : airport.id;

    queryClient.setQueryData(['airports', 'item', airportId, airportIdKey], airport);
  }

  return airport || null;
};
